document.addEventListener('DOMContentLoaded', function () {
  console.log("DOM vollständig geladen und Skript ausgeführt");

  // Funktion zur Weiterleitung zur Shopify-Suchseite
  function redirectToSearch(searchInputId) {
    const searchQuery = document.getElementById(searchInputId).value.trim();
    if (searchQuery) {
      const searchURL = `/search?q=${encodeURIComponent(searchQuery)}&type=product`;
      window.location.href = searchURL;
    }
  }

  // Event-Listener für die Enter-Taste im Desktop-Suchfeld
  const desktopSearchInput = document.getElementById('product-search-input');
  if (desktopSearchInput) {
    desktopSearchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        redirectToSearch('product-search-input');
      }
    });
  }

  // Event-Listener für die Enter-Taste im mobilen Suchfeld
  const mobileSearchInput = document.getElementById('mobile-product-search-input');
  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        redirectToSearch('mobile-product-search-input');
      }
    });
  }

  // Funktion zum Hinzufügen eines Produkts in den Warenkorb
  function addToCart(productId, quantity = 1) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: productId, quantity: quantity }),
    })
      .then(response => response.json())
      .then(data => {
        console.log("Produkt hinzugefügt:", data);
        updateCartDisplay();
      })
      .catch(error => {
        console.error("Fehler beim Hinzufügen zum Warenkorb:", error);
      });
  }

  // Funktion zur Aktualisierung der Warenkorbanzeige
  function updateCartDisplay() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('.cart-total').forEach(span => {
          span.textContent = `${cart.total_price / 100} € (${cart.item_count})`;
        });
      })
      .catch(error => {
        console.error("Fehler beim Abrufen des Warenkorbs:", error);
      });
  }

  // Event-Listener für die "In den Warenkorb"-Buttons
  document.querySelectorAll('.add-to-cart-button').forEach(button => {
    button.addEventListener('click', function () {
      const productId = this.getAttribute('data-product-id');
      addToCart(productId);
    });
  });

  // Initiales Laden der Warenkorbanzeige
  updateCartDisplay();

  // Funktion für die Kategoriefilterung
  function filterByCategory(selectedCategory) {
    const products = document.querySelectorAll('.product-item');

    products.forEach(product => {
      const productType = product.getAttribute('data-product-type').toLowerCase();
      if (productType === selectedCategory) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  }

  // Event-Listener für die Kategorie-Buttons
  document.querySelectorAll('.category-filter').forEach(button => {
    button.addEventListener('click', function () {
      const selectedCategory = this.getAttribute('data-product-type').toLowerCase();
      console.log("Kategorie geklickt:", selectedCategory);
      filterByCategory(selectedCategory);
    });
  });

  // Funktion zum Umschalten der Sidebar (für mobile Ansicht)
  function toggleSidebar() {
    const sidebar = document.querySelector('.product-sidebar');
    sidebar.classList.toggle('open');
  }

  // Event-Listener für den Sidebar-Button
  const sidebarToggleButton = document.querySelector('.sidebar-toggle-button');
  if (sidebarToggleButton) {
    sidebarToggleButton.addEventListener('click', toggleSidebar);
  }
});
